import React, { useState } from 'react'
import _, { debounce } from 'lodash'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Upload,
  Icon,
  Select,
  Spin,
  DatePicker
} from 'antd'

import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import {
  beforeUpload,
  compressFile,
  getBase64
} from '../../../../utils/services'

import { useDispatch, useSelector } from 'react-redux'
import { getAllHeroes } from '../../../../modules/hero'
import moment from 'moment'
import axios from 'axios'

const initialOptions = {
  page: 0,
  size: 20,
  keyword: '',
  isLoma: true
}

const PackagesForm = (props) => {
  const dispatch = useDispatch()
  const { visible, onOk, onCancel, formData, form, formPackageData } = props
  const { getFieldDecorator, validateFields, setFieldsValue, getFieldValue } =
    form
  const [imageUrl, setImageUrl] = useState('')
  const [filterOption, setFilterOption] = useState(initialOptions)
  const [loading, setLoading] = useState(false) // <-- เพิ่มตัวแปร state เพื่อล็อกปุ่ม
  const [packageTypeFilter, setPackageTypeFilter] = useState('MAIN')

  const [valueHero, setValueHero] = useState([])

  const { heroList, isLoading } = useSelector(
    (state) => ({
      heroList: state.hero.heroList,
      isLoading: state.hero.isLoading
    }),
    []
  )

  const debounceSearch = debounce((value) => {
    handleChangeSearch(value)
  }, 1000)

  const handleDebouncedSearch = (value) => {
    debounceSearch(value)
  }

  async function handleChangeSearch(value) {
    filterOption.keyword = '%' + value + '%'
    await dispatch(getAllHeroes(filterOption))
  }

  async function fetch() {
    if (_.isEmpty(formData)) {
      await dispatch(getAllHeroes(filterOption))
    }
  }

  useDeepEffect(() => {
    fetch()
    if (!_.isEmpty(formData)) {
      setValueHero([{ key: formData.heroId, label: formData.heroName }])
      setFieldsValue({
        heroId: [{ key: formData.heroId, label: formData.heroName }],
        packageId: formData.packageId
      })
    } else {
      setPackageTypeFilter('MAIN')
    }

    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    if (loading) return // <-- ถ้ากำลังโหลด ห้ามกดซ้ำ

    setLoading(true) // <-- ล็อกปุ่มเมื่อกด submit
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          heroId: values.heroId[0].key,
          packageId: values.packageId,
          billingCycle: isCustomPricing ? null : values.billingCycle,
          startDate: values.startDate,
          paymentDate: values.paymentDate,
          remark: values.remark ? values.remark : null
        }

        if (values.slipImage) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.slipImage.file)) {
              formImgData.append(
                'image',
                await compressFile(values.slipImage.file)
              )
              const token = localStorage.getItem('user-token')
              const authorizationHeader = token ? token : ''
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT +
                  `/subscription-package/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data',
                    Authorization: authorizationHeader
                  }
                }
              )
              console.log('res slipImage : ', res)
              data.slipImage = res.data.url
            }
          } catch (err) {
            console.log(err)
          }
        } else {
          data.slipImage = null
        }

        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }

        await onOk(data) // <-- ทำให้แน่ใจว่า process เสร็จก่อน
        clearValueHero()
      }
      setLoading(false) // <-- ปลดล็อกปุ่มเมื่อ process เสร็จ
    })
  }

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  function handleChangeSelectHero(value) {
    if (value.length > 1) {
      return
    }
    setValueHero(value)
  }

  const clearValueHero = () => {
    setValueHero([])
    filterOption.keyword = ''
    form.resetFields()
    setImageUrl('')
  }

  const handleCancel = () => {
    if (!formData) {
      clearValueHero()
    }
    onCancel()
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  const heroListContent = heroList.content || []

  const selectedPackageId = getFieldValue('packageId')
  const selectedPackage = formPackageData.find(
    (item) => item.id === selectedPackageId
  )
  const isCustomPricing =
    !!selectedPackage &&
    selectedPackage.priceMonthly == null &&
    selectedPackage.priceYearly == null

  return (
    <Modal
      title={`${
        !_.isEmpty(formData) ? 'ต่ออายุแพ็กเกจ' : 'เพิ่มการสมัครแพ็กเกจ'
      }`}
      visible={visible}
      footer={null}
      onCancel={handleCancel}
      width={600}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="LOMA User ที่ต้องการสมัคร">
          {getFieldDecorator(`heroId`, {
            rules: [{ required: true, message: 'กรุณากรอก' }],
            initialValue: valueHero
          })(
            <Select
              mode="multiple"
              labelInValue
              value={Array.isArray(valueHero) ? valueHero : []}
              placeholder="ค้นหาด้วยชื่อฮีโร่ ชื่อร้าน เบอร์โทรศัพท์ อีเมล"
              notFoundContent={isLoading ? <Spin size="small" /> : null}
              filterOption={false}
              onSearch={handleDebouncedSearch}
              onChange={handleChangeSelectHero}
              style={{ width: '100%' }}
              disabled={Array.isArray(valueHero) && valueHero.length >= 1}>
              {heroListContent.map((d) => (
                <Select.Option key={d.id}>{d.name}</Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        {!formData && (
          <Form.Item label="ประเภทแพ็กเกจ">
            <Radio.Group
              value={packageTypeFilter}
              onChange={(e) => {
                setPackageTypeFilter(e.target.value)
                setFieldsValue({ packageId: undefined })
              }}>
              <Radio value="MAIN">แพ็กเกจหลัก</Radio>
              <Radio value="ADDON">แพ็กเกจเสริม</Radio>
            </Radio.Group>
          </Form.Item>
        )}
        <Form.Item label="แพ็กเกจที่ต้องการสมัคร">
          {getFieldDecorator(`packageId`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(
            <Select
              placeholder="เลือกแพ็กเกจที่ต้องการ"
              disabled={formData ? true : false}
              onChange={() => setFieldsValue({ billingCycle: 'MONTHLY' })}>
              {formPackageData
                .filter(
                  (item) =>
                    !!formData ||
                    (item.packageType || 'MAIN') === packageTypeFilter
                )
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}{' '}
                    <span style={{ color: '#969696' }}>
                      {' '}
                      : ราคา {item.price} บาท
                    </span>
                  </Select.Option>
                ))}
            </Select>
          )}
        </Form.Item>
        {!formData && isCustomPricing && (
          <Form.Item label="รอบการชำระ">
            <Input disabled value={`กำหนดเอง (${selectedPackage.time} วัน)`} />
          </Form.Item>
        )}
        {!formData && !isCustomPricing && (
          <Form.Item label="รอบการชำระ">
            {getFieldDecorator(`billingCycle`, {
              initialValue: 'MONTHLY',
              rules: [{ required: true, message: 'กรุณาเลือก' }]
            })(
              <Select placeholder="เลือกรอบการชำระ">
                <Select.Option value="MONTHLY">รายเดือน</Select.Option>
                <Select.Option value="YEARLY">รายปี</Select.Option>
              </Select>
            )}
          </Form.Item>
        )}
        {!formData && (
          <Form.Item label="วันที่เริ่มใช้งาน">
            {getFieldDecorator(`startDate`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(
              <DatePicker
                disabledDate={(current) =>
                  current && current < moment().startOf('day')
                }
              />
            )}
          </Form.Item>
        )}
        <Form.Item label="วันที่ชำระเงิน">
          {getFieldDecorator(`paymentDate`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(
            <DatePicker
              disabledDate={(current) =>
                current && current > moment().endOf('day')
              }
            />
          )}
        </Form.Item>
        <Form.Item label="หลักฐานการจ่ายเงิน(ถ้ามี)">
          {getFieldDecorator(`slipImage`)(
            <Upload
              name="img"
              listType="picture-card"
              showUploadList={false}
              beforeUpload={(file) => beforeUpload(file)}
              onChange={handleChange}>
              {imageUrl ? (
                <img src={imageUrl} alt="img" style={{ width: '100%' }} />
              ) : (
                uploadButton
              )}
            </Upload>
          )}
        </Form.Item>
        <Form.Item label="remark">
          {getFieldDecorator(`remark`)(
            <Input
              name="remark"
              placeholder="หมายเหตุ"
            />
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => handleCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              htmlType="submit"
              disabled={loading} // <-- ปิดปุ่มขณะรอ response
            >
              {loading ? "กำลังบันทึก..." : "บันทึก"}
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedPackagesForm = Form.create({ name: 'PackagesForm' })(PackagesForm)
export default WrappedPackagesForm